import PropTypes from 'prop-types';

/** Shared routes PropTypes shape for BaseRouter and BaseUserRouter. */
export const routesPropTypes = PropTypes.shape({
  DASHBOARD: PropTypes.string.isRequired,
  USERS: PropTypes.string.isRequired,
  OWNERS: PropTypes.string.isRequired,
  PENSIONERS: PropTypes.string.isRequired,
  SUPERVISIONS: PropTypes.string.isRequired,
  RESERVATIONS: PropTypes.string.isRequired,
  SUPERVISION_PRICES: PropTypes.string.isRequired,
  INVOICES: PropTypes.string.isRequired,
  TEMPLATE_DOCS: PropTypes.string.isRequired
}).isRequired;
